
export default function IntroSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Apresentação Institucional
            </h2>
            
            <div className="space-y-4 text-[#3F3F3F] leading-relaxed">
              <p>
                Na P&P Engenharia e Arquitetura, cada projeto é desenvolvido para quem enxerga o espaço como uma extensão do estilo de vida — ou da identidade da marca.
              </p>
              
              <p>
                Unimos design autoral, precisão técnica e funcionalidade, entregando projetos arquitetônicos de alto padrão que se destacam pela harmonia entre estética e engenharia.
              </p>
              
              <p>
                Atuamos em São Paulo e em diversas regiões do país, sempre com foco em exclusividade, conforto e performance.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-[#F2F2F2]">
              <div className="text-center">
                <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                  100+
                </div>
                <div className="text-sm text-[#3F3F3F] font-medium">Projetos Entregues</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                  6+
                </div>
                <div className="text-sm text-[#3F3F3F] font-medium">Anos de Experiência</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                  100%
                </div>
                <div className="text-sm text-[#3F3F3F] font-medium">Satisfação</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/8f9607eca05ab2e446965cb3b7abaa69.jpeg"
              alt="Escritório P&P Engenharia e Arquitetura"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
            />
            
            {/* Decorative Element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#5C1A24] rounded-2xl opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
